import { useContext, useEffect } from "react";
import { Badge, Card } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import EmptyData from "./../../../helpers/EmptyData/EmptyData";
import { qrCodeCustomerContext } from "../../../context/CustomerContext/QrCodeCustomerContext/QrCodeCustomerContext";
import { Col, Row } from "../../../components/Grid/Grid";

const QrCodeCustomer = () => {
  const { qrCode, handleGetQrCode } = useContext(qrCodeCustomerContext);

  useEffect(() => {
    handleGetQrCode();
  }, []);

  return (
    <>
      <SiteTitle title="بارکد کیف پول" />

      {isEmpty(qrCode) ? (
        <Card body>
          <EmptyData title="بارکدی برای نمایش یافت نشد" />
        </Card>
      ) : (
        <Row className="justify-content-center">
          <Col size="12" sm="8" md="6" xxl="4">
            <Card body>
              <h4 className="text-center mb-4">
                بارکد زیر را توسط فروشگاه اسکن کنید
              </h4>
              <Card body>
                <QRCodeSVG value={qrCode} style={{ width: "100%" }} />
              </Card>
              <p className="text-center mt-4">
                اعتبار بارکد :{" "}
                <Badge
                  id="otpCountdown"
                  className="badge-dim font-weight-bold"
                  color="primary"
                >
                  -
                </Badge>{" "}
                ثانیه
              </p>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default QrCodeCustomer;
